<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "ShippingForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        warehouse_id: null,
        shipper_id: null,
        status_slug: null,
        imputation_number: "R.1LG.19003-50"
      },
      isBusy: false
    };
  },
  computed: {
    options: function() {
      return {
        warehouse_id_options: this.$store.getters[
          "warehouse/getAll"
        ].selectOptions("id", "name"),
        shipper_id_options: this.$store.getters["company/getByTypeCode"](
          "TRSP"
        ).selectOptions("id", "name"),
        status_slug_options: this.$store.getters["status/getByGroup"](
          "shipping"
        ).selectOptions("status_slug", "name")
      };
    }
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {
          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            warehouse_id: item.warehouse ? item.warehouse.id : null,
            renting_preparation_id: item.renting_preparation
              ? item.renting_preparation.id
              : null,
            shipper_id: item.shipper ? item.shipper.id : null,
            status_slug: item.status ? item.status.status_slug : null,
            shipping_date: item.shipping_date
              ? this.$moment(item.shipping_date).format("YYYY-MM-DD")
              : null,
            imputation_number: item.imputation_number || "R.1LG.19003-50"
          };
          this.isBusy = false;
        });
    }

    this.$store.dispatch("warehouse/getAllForSelect");
    this.$store.dispatch("company/getAllForSelect");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Shipping/ShippingForm.vue